import { FC } from "react";
import {
  Create,
  CreateProps,
  FormGroupContextProvider,
  FormWithRedirect,
  maxValue,
  minValue,
  NumberInput,
  required,
} from "react-admin";

import CustomCard from "../../components/CustomCard";
import CustomToolbar from "../../components/CustomToolbar";
import FormWrapper from "../../components/FormWrapper";
import Spacing from "../../components/Spacing";
import useDisabledOnLoading from "../../hooks/useDisabledOnLoading";
import { FormGroupNames } from "../../types/reactAdmin.types";
import { AppResource } from "../../types/resource.types";
import { int } from "../../utils/validators";
import { useUserGuideLocalizations } from "./utils";

const CustomForm: FC<CustomFormProps> = (props) => {
  const { disabledStyles } = useDisabledOnLoading();
  const localizedInputs = useUserGuideLocalizations(props);

  return (
    <FormWrapper>
      <FormGroupContextProvider name={FormGroupNames.faqsCreate}>
        <FormWithRedirect
          {...props}
          redirect={`/${AppResource.faqs}`}
          render={(formProps) => {
            return (
              <form style={disabledStyles}>
                <CustomCard title="Faqs">
                  <NumberInput
                    variant="outlined"
                    source="sortIndex"
                    style={{ width: "100%" }}
                    validate={[required(), int(), minValue(0), maxValue(100)]}
                  />

                  <Spacing>
                    {localizedInputs?.[0]}
                    {localizedInputs?.[1]}
                  </Spacing>

                  <Spacing>
                    {localizedInputs?.[2]}
                    {localizedInputs?.[3]}
                  </Spacing>
                </CustomCard>

                <CustomToolbar {...formProps} formName={FormGroupNames.faqsCreate} />
              </form>
            );
          }}
        />
      </FormGroupContextProvider>
    </FormWrapper>
  );
};

const FaqsCreate: FC<CreateProps> = (props) => {
  return (
    <Create {...props} component="section">
      <CustomForm />
    </Create>
  );
};

interface CustomFormProps {
  [key: string]: any;
}

export default FaqsCreate;
